<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Header -->
							<div class="page_header">{{ pageTitle }}</div>
							<!-- Header -->
				
							<div class="page_main">
				
								<!-- <div class="btn_el">
									<div class="tips">
										Please complete the document type name and sorting order. 
										After saving, configure the corresponding approval workflow.
									</div>
								</div> -->
				
								<div v-if="pageTitle == 'Edit Document Type'" class="btn_el">
									<div class="tips">
										Modify the document type name and sorting order
									</div>
								</div>
				
								<div class="form_box">
									<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px">
				
										<div class="input_el">
											<div class="tit required">
												Document Type Name
											</div>
				
											<el-form-item label="" prop="title">
												<el-input 
													v-model="ruleForm.title" 
													placeholder="Please enter" 
													clearable>
												</el-input>
											</el-form-item>
										</div>
				
				
										<div class="input_el">
											<div class="tit required">
												Document Type Sort Order
											</div>
				
											<el-form-item label="" prop="sort">
												<el-input 
													v-model="ruleForm.sort" 
													placeholder="Please enter">
												</el-input>
											</el-form-item>
										</div>
				
									</el-form>
								</div>
				
				
								<div class="btn_box">
									<van-button 
										class="btn_el" 
										type="default" 
										round 
										@click="cancel">
										Cancel
									</van-button>
				
									<van-button 
										class="btn_el" 
										round 
										color="linear-gradient(to right, #7BC1FF, #4886FF)" 
										@click="submitForm('ruleForm')">
										Save
									</van-button>
								</div>
				
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import { resourcesLeixingAdd, resourcesLeixingEdit, resourcesLeixingDetail } from '@/api/docManage/configureDocControl/index';
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
export default {
	components:{
		headers,
		slider
	},
	data() {
		return {
			isLoading: true,
			pageTitle: '',
			ruleForm: {
				title: '',
				sort: ''
			},
			rules: {
				title: [
					{ required: true, message: 'Please enter', trigger: 'blur' },
				],
				sort: [
					{ required: true, message: 'Please enter', trigger: 'blur' },
				]
			}
		}
	},
	created(){
		let that = this;
		if(that.$route.query.oid) {
			that.pageTitle = 'Edit Document Type';
			resourcesLeixingDetail({ id: that.$route.query.oid }).then(res => {
				if(res.code == 200) {
					that.ruleForm = {
						id: res.data.id,
						title: res.data.title,
						sort: res.data.sort
					};
				}else {
					
				}
			});
			that.isLoading = false;
		}else {
			that.pageTitle = 'Add Document Type';
			that.isLoading = false;
		}
	},
	mounted() {
		let that = this;
	},
	watch: {
		//
	},
	methods: {
		//取消
		cancel() {
			this.$router.back();
		},
		//保存
		submitForm(formName) {
			let that = this;
			that.$refs[formName].validate((valid) => {
				if(valid) {
					that.$toast.loading({ duration: 0, forbidClick: true });
					if(that.pageTitle == 'Add Document Type') {
						resourcesLeixingAdd(that.ruleForm).then(res => {
							if(res.code == 200) {
								that.$toast.clear();
								that.$message.success('Operation successful');
								setTimeout(() => {
									window.location.reload();
								}, 800);
							}else {
								
							}
						});
					}else if(that.pageTitle == 'Edit Document Type') {
						resourcesLeixingEdit(that.ruleForm).then(res => {
							if(res.code == 200) {
								that.$toast.clear();
								that.$message.success('Operation successful');
								setTimeout(() => {
									window.location.reload();
								}, 800);
							}else {
								
							}
						});
					}
				}else {
					return false;
				}
			});
		}
	}
}
</script>

<style lang="less" scoped>
//主要内容
.main_main{
	.page_main{
		padding: 18px 20px;
		.btn_box{
			text-align: center;
			.btn_el{
				margin-left: 10px;
				padding: 12px 24px;
				.van-button__text{
					font-size: 16px;
				}
			}
		}
		.form_box{
			.input_el{
				.tit{
					padding-bottom: 5px;
					font-size: 14px;
					color: #333333;
				}
				.required::before {
					content: '*';
					color: red;
					margin-right: 2px;
				}
			}
		}
		.btn_el{
			margin: 10px 0 20px 0;
			.tips{
				padding: 6px 8px;
				background-color: #ffb1001a;
				border-radius: 6px;
				font-size: 16px;
				font-weight: bold;
			}
		}
	}
	//页头
	.page_header{
		padding: 0 20px;
		height: 60px;
		line-height: 60px;
		background-color: #d8e4f0;
		font-size: 24px;
		font-weight: bold;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
	}
}
</style>
<style scoped>
.main_box{
	height: calc(100vh - 60px);
	overflow-y: auto;
}
.main_box .main_main{
	position: relative;
	min-height: calc(100% - 0px);
	max-height: auto;
	background-color: #FAFAFA;
}
.el-header, .el-main{
	padding: 0;
}
</style>

